export default __webpack_public_path__ + "static/media/empty-noti.d68f85ae.svg";